export const ORDER_SUCCESS = 'neo-trading/tradepanel/ORDER_SUCCESS';
export const ORDER_SUCCESS_TYPE = 'neo-trading/tradepanel/ORDER_SUCCESS_TYPE';
export const UPDATE_TRADE_SOCKET_DATA = 'neo-trading/tradepanel/UPDATE_TRADE_SOCKET_DATA';
export const HIDE_MODAL = 'neo-trading/tradepanel/HIDE_MODAL';
export const LOAD_TRADE_SOCKET_DATA = 'neo-trading/tradepanel/LOAD_TRADE_SOCKET_DATA';
export const CLOSE_SOCKET_TRADE = 'neo-trading/tradepanel/CLOSE_SOCKET_TRADE';
export const EXECUTE_SUCCESS = 'neo-trading/tradepanel/EXECUTE_SUCCESS';
export const GETBM='neo-trading/tradepanel/GETBM';
export const GETBM_SUCCESS='neo-trading/tradepanel/GETBM_SUCCESS';
export const GETBM_FAILURE='neo-trading/tradepanel/GETBM_FAILURE';
export const SHOW_ALERT='neo-trading/tradepanel/SHOW_ALERT';
export const HIDE_ALERT='neo-trading/tradepanel/HIDE_ALERT';
export const TRD_STATUS='neo-trading/tradepanel/TRD_STATUS';
export const CUTOFF_BENCHMARK='neo-trading/tradepanel/CUTOFF_BENCHMARK';
export const UPDATE_BM_LIST='neo-trading/tradepanel/UPDATE_BM_LIST';
export const UPDATE_POPOUT_COUNT='neo-trading/tradepanel/UPDATE_POPOUT_COUNT';
export const CLOSE_WEBSOCKET_TRADE = 'neo-trading/tradepanel/CLOSE_WEBSOCKET_TRADE';
export const ORDER_SELECTION_SUCCESS_TYPE = 'neo-trading/tradepanel/ORDER_SELECTION_SUCCESS_TYPE';
export const UPDATE_STATUS_CHANGE = 'neo-trading/tradepanel/UPDATE_STATUS_CHANGE';
export const UPDATE_ORDER_STATUS ='neo-trading/tradepanel/UPDATE_ORDER_STATUS';
export const GET_WS_MESSAGE ='neo-trading/tradepanel/GET_WS_MESSAGE';
